import { render, staticRenderFns } from "./YoutubeTemplate.vue?vue&type=template&id=68840f39&"
import script from "./YoutubeTemplate.vue?vue&type=script&lang=js&"
export * from "./YoutubeTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/lili/Sites/southern-highlands.com.au-2018/web/app/themes/wisdom/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('68840f39', component.options)
    } else {
      api.reload('68840f39', component.options)
    }
    module.hot.accept("./YoutubeTemplate.vue?vue&type=template&id=68840f39&", function () {
      api.rerender('68840f39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/scripts/vue/YoutubeTemplate.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/YoutubeTemplate.vue
// module id = 117
// module chunks = 9